import { Injector, NgModule } from '@angular/core';
import { ZipcodePopoverComponent } from '../components/zipcode-popover/zipcode-popover.component';
import { createCustomElement } from '@angular/elements';
import { CONSTANTS } from '../global';
import { DtAnZipcodeSharedModule } from './dt-an-zipcode-shared.module';

import { HttpClientModule } from '@angular/common/http';


@NgModule({
  declarations: [
    ZipcodePopoverComponent,
  ],
  imports: [
    HttpClientModule,
    DtAnZipcodeSharedModule
  ],
  exports: [
    ZipcodePopoverComponent
  ]
})
export class DtAnZipcodewidgetLibModule {
  constructor(private injector: Injector) {
    if (!customElements.get(CONSTANTS.ELEMENT_NAME)) {
      const popoverElement = createCustomElement(ZipcodePopoverComponent, { injector });
      customElements.define(CONSTANTS.ELEMENT_NAME, popoverElement);

      const containerElements = document.querySelectorAll(CONSTANTS.CLASS_SELECTOR);
      containerElements.forEach(element => {
        element.appendChild(document.createElement(CONSTANTS.ELEMENT_NAME) as any);
      });
    }
  }
}
